import { render, staticRenderFns } from "./PlanPricingHeader.vue?vue&type=template&id=56a2c483&scoped=true"
import script from "./PlanPricingHeader.vue?vue&type=script&lang=js"
export * from "./PlanPricingHeader.vue?vue&type=script&lang=js"
import style0 from "./PlanPricingHeader.vue?vue&type=style&index=0&id=56a2c483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2c483",
  null
  
)

export default component.exports